import React from 'react';
import {IconProps} from './IconProps';
import cn from 'classnames';

export default function IconInfoLight({className, height = '1rem'}: IconProps) {
  return (
    <svg width={height} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
         className={cn(className, 'inline-block')}>
      <path
        d="M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z"
        stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10 6.5H10.0056" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9 9.25H9.99998V13.25H11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
            strokeLinejoin="round"/>
    </svg>
  );
}
